import { PageId } from 'constants/pages'
import type { TStep } from 'src/types'

export const STEPS_INTL_3: TStep[] = [
  {
    pageId: PageId.ANALYZING_INTL_3,
  },
  {
    pageId: PageId.START_INTL_3,
  },
  {
    pageId: PageId.PUZZLES_ENJOYMENT_INTL_3,
  },
  {
    pageId: PageId.APPLY_KNOWLEDGE_REAL_LIFE_INTL_3,
  },
  {
    pageId: PageId.NOTICE_PATTERNS_INTL_3,
  },
  {
    pageId: PageId.STAY_CURIOUS_INTL_3,
  },
  {
    pageId: PageId.LONG_FOCUS_INTL_3,
  },
  {
    pageId: PageId.PERSONALIZE_TEST_FEEDBACK_INTL_3,
  },
  {
    pageId: PageId.QUESTION_11_INTL_3,
  },
  {
    pageId: PageId.QUESTION_7_INTL_3,
  },
  {
    pageId: PageId.QUESTION_3_INTL_3,
  },
  {
    pageId: PageId.QUESTION_4_INTL_3,
  },
  {
    pageId: PageId.SPEED_FEEDBACK_INTL_3,
  },
  {
    pageId: PageId.QUESTION_5_INTL_3,
  },
  {
    pageId: PageId.QUESTION_6_INTL_3,
  },
  {
    pageId: PageId.QUESTION_2_INTL_3,
  },
  {
    pageId: PageId.QUESTION_8_INTL_3,
  },
  {
    pageId: PageId.QUESTION_9_INTL_3,
  },
  {
    pageId: PageId.QUESTION_10_INTL_3,
  },
  {
    pageId: PageId.QUESTION_1_INTL_3,
  },
  {
    pageId: PageId.QUESTION_12_INTL_3,
  },
  {
    pageId: PageId.SMARTNESS_FEEDBACK_INTL_3,
  },
  {
    pageId: PageId.QUESTION_13_INTL_3,
  },
  {
    pageId: PageId.QUESTION_14_INTL_3,
  },
  {
    pageId: PageId.QUESTION_15_INTL_3,
  },
  {
    pageId: PageId.QUESTION_16_INTL_3,
  },
  {
    pageId: PageId.QUESTION_17_INTL_3,
  },
  {
    pageId: PageId.QUESTION_18_INTL_3,
  },
  {
    pageId: PageId.QUESTION_19_INTL_3,
  },
  {
    pageId: PageId.QUESTION_20_INTL_3,
  },
  {
    pageId: PageId.LOGICAL_SKILLS_FEEDBACK_INTL_3,
  },
  {
    pageId: PageId.QUESTION_21_INTL_3,
  },
  {
    pageId: PageId.QUESTION_22_INTL_3,
  },
  {
    pageId: PageId.QUESTION_23_INTL_3,
  },
  {
    pageId: PageId.QUESTION_24_INTL_3,
  },
  {
    pageId: PageId.QUESTION_25_INTL_3,
  },
  {
    pageId: PageId.AGE_QUESTION_INTL_3,
  },
  {
    pageId: PageId.EDUCATION_QUESTION_INTL_3,
  },
  {
    pageId: PageId.DISCOVER_FEEDBACKS_INTL_3,
  },
  {
    pageId: PageId.PREPARE_FLOW_INTL_3,
  },
  {
    pageId: PageId.EMAIL_INTL_3,
  },
  {
    pageId: PageId.OFFER_INTL_3,
  },
  {
    pageId: PageId.SPECIAL_DISCOUNT_INTL_3,
  },
  {
    pageId: PageId.CANCEL_OFFER_INTL_3,
  },
  {
    pageId: PageId.PAYMENT_INTL_3,
  },
  {
    pageId: PageId.REGISTRATION_INTL_3,
  },
  {
    pageId: PageId.NAME_ENTRY_INTL_3,
  },
  {
    pageId: PageId.CERTIFICATE_INTL_3,
  },
  {
    pageId: PageId.REPORT_INTL_3,
  },
]
